export default __webpack_public_path__ + "static/media/team74.8211ac60.JPG";